import * as React from 'react';
import './simpleMobileNavigation.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { CurrentUserState } from '../../../../mainv2/states/CurrentUserState';
import DefaultUserProfile from '../default-user-profile.png';
import { HeaderLogo } from '../../../components/atoms/Logo';
import { NotificationIcon } from '../NotificationIcon';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes/index';
import { StylableProps } from '../../../../commonv3/types/props';

type UserInfoProps = {
  currentUser: CurrentUserState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: () => any;
};

const UserInfo = observer(({ currentUser, onClick }: UserInfoProps) => {
  if (currentUser.isSignedIn()) {
    const { profile_url } = currentUser.currentUser;
    return (
      <div onClick={onClick}>
        <img styleName="profile" src={profile_url ? profile_url : DefaultUserProfile} />
      </div>
    );
  } else {
    return null;
  }
});

type Props = {
  logo?: React.ComponentType<StylableProps>;
  showNotificationIcon?: boolean;
};

export const SimpleMobileNavigation = observer(
  class SimpleMobileNavigation extends React.Component<Props> {
    render() {
      const { showNotificationIcon = true } = this.props;
      const currentUser = GlobalStatesV3.currentUser;
      const DefaultLogo = (props: StylableProps) => (
        <HeaderLogo {...props} onClick={() => GlobalStatesV3.routing.push('/')} />
      );
      const Logo = this.props.logo || DefaultLogo;
      return (
        <div styleName="nav-wrapper">
          <div styleName="nav-top">
            <Logo styleName="logo" />
            <div styleName="icons">
              {showNotificationIcon && <NotificationIcon />}
              <UserInfo currentUser={currentUser} onClick={() => routingStore.push(V3Routes.myPage())} />
            </div>
          </div>
        </div>
      );
    }
  }
);
